import React, { useCallback } from 'react';

import { Col, Row, Card, Typography, Button, Spin, Table } from 'antd';
import { useHistory } from 'react-router-dom';

import Layout from 'layout/AdminLayout';

import { useOrganizationList } from './Organizations.state';
import ColumnsDefinition from './components/ColumnsDefinition';

export default function Organizations(): JSX.Element | null {
  const history = useHistory();

  const [organizations] = useOrganizationList();

  const createOrganization = useCallback(() => {
    history.push('/organizations/create');
  }, [history]);

  return !true ? null : (
    <Layout>
      <Row className="mb-3">
        <Col span={24}>
          <Card>
            <Row align="middle" justify="space-between">
              <Col>
                <Typography.Title>Organizations</Typography.Title>
              </Col>
              <Col>
                <Button type="primary" className=" btn-primary" onClick={createOrganization}>
                  New Organizations
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row justify="center">
        <Col span={23}>
          <Card>
            <Spin spinning={organizations === null}>
              <Table dataSource={organizations || []} columns={ColumnsDefinition} scroll={{ x: true }} />
            </Spin>
          </Card>
        </Col>
      </Row>
    </Layout>
  );
}
